<template>
  <div class="logo">
    <img
      src="../assets/HK_Lockup_RGB_Schwarz.svg"
      alt="Logo HKS"
      width="440"
      height="117"
    >
  </div>
</template>

<script>
export default {
  name: 'CLogo'
}
</script>

<style lang="scss" scoped>
.logo {
  display: flex;
  align-items: flex-end;
  flex-wrap: wrap;
  gap: 3em;

  margin-bottom: 3em;
}
</style>
